(() => {
  const SELECTOR = "[data-now-playing]";
  const DEFAULT_POLL_SECONDS = 25;

  async function getNowPlaying(endpoint) {
    const r = await fetch(endpoint, { cache: "no-store" });
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    return await r.json();
  }

  function updateAll(text, url) {
    document.querySelectorAll(SELECTOR).forEach((el) => {
      // If you want it clickable when playing
      if (url && text) {
        el.innerHTML = `<a href="${url}" target="_blank" rel="noopener noreferrer">${text}</a>`;
      } else {
        el.textContent = text || "";
      }
    });
  }

  async function tick() {
    const els = [...document.querySelectorAll(SELECTOR)];
    if (!els.length) return;

    // Use the first element’s endpoint/poll settings
    const endpoint = els[0].dataset.endpoint;
    const pollSeconds = parseInt(els[0].dataset.poll || DEFAULT_POLL_SECONDS, 10);

    if (!endpoint) return;

    try {
      const data = await getNowPlaying(endpoint);
      // If not playing, choose a fallback message (or blank)
      const fallback = els[0].dataset.fallback || "☯︎ Listening inward ☯︎";
const text =
  data?.isPlaying && data?.title && data?.artist
    ? `♫ Currently listening to ${data.title} by ${data.artist} ♫`
    : fallback;

const url = data?.isPlaying ? (data?.url || "") : "";
updateAll(text, url);
    } catch (e) {
      // Fail quietly (don’t break the page)
      // console.error("Now playing error:", e);
    }

    setTimeout(tick, pollSeconds * 1000);
  }

  // Start once DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", tick);
  } else {
    tick();
  }
})();
